// #141 "Planlanan Araç" seçim çubuğu — tek-seçim SelectBox + araç çipleri.
// Select yalnızca ekranın üstünde seçili distribütörün araçlarını listeler. Çipler
// hem hızlı seçim hem de DROP TARGET'tır: bir siparişi başka araca buradan kaydırabilirsiniz
// (araçlar arası taşıma). Seçili aracın bilgileri altta (VehicleDetailPanel) listelenir.
import { useMemo, useState } from 'react';
import { vehicleTotals, fillColor } from './shipmentPlanningUtils';

const keyOf = (v) => v.id || v.shipmentVehicleId;

export default function VehicleSelectBar({
  vehicles = [], vendorId, selectedVehicleId, onSelect, onDropToVehicle,
}) {
  const [overKey, setOverKey] = useState(null);

  // #214 Üstte seçili Distribütör (Vendor) varsa yalnız o kanalın araçları.
  const list = useMemo(() => {
    if (!vendorId) return vehicles;
    const filtered = vehicles.filter((v) => String(v.vendorId || '') === String(vendorId));
    return filtered.length ? filtered : vehicles;
  }, [vehicles, vendorId]);

  if (!vehicles.length) return null;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
      background: 'var(--bg-card,#fff)', border: '1px solid var(--border-color,#e5e7eb)',
      borderRadius: 14, padding: '10px 12px',
    }}>
      <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12.5, fontWeight: 800, color: 'var(--text-secondary,#475569)', whiteSpace: 'nowrap' }}>
        <span aria-hidden="true">🚚</span> Planlanan Araç
      </label>
      <select
        value={selectedVehicleId != null ? String(selectedVehicleId) : ''}
        onChange={(e) => {
          const v = list.find((x) => String(keyOf(x)) === e.target.value);
          if (v) onSelect?.(keyOf(v));
        }}
        style={{
          minWidth: 220, padding: '8px 10px', borderRadius: 10,
          border: '1px solid var(--border-color,#cbd5e1)', background: 'var(--input-bg,#fff)',
          color: 'var(--text-primary,#1f2937)', fontSize: 13, fontWeight: 700, cursor: 'pointer',
        }}
      >
        <option value="" disabled>Araç seçin…</option>
        {list.map((v) => {
          const t = vehicleTotals(v);
          return <option key={keyOf(v)} value={String(keyOf(v))}>{v.plaka} — {t.count} sipariş</option>;
        })}
      </select>

      {/* Araç çipleri (drop target + hızlı seçim) */}
      <div style={{ display: 'flex', gap: 7, flexWrap: 'wrap', flex: 1, minWidth: 0 }}>
        {list.map((v) => {
          const k = keyOf(v);
          const t = vehicleTotals(v);
          const wRatio = v.maxWeight > 0 ? t.weight / v.maxWeight : 0;
          const vRatio = v.volume > 0 ? t.volume / v.volume : 0;
          const ratio = Math.max(wRatio, vRatio);
          const isSel = String(k) === String(selectedVehicleId);
          const isOver = String(k) === String(overKey);
          const barColor = fillColor(ratio);
          return (
            <button
              key={k}
              type="button"
              onClick={() => onSelect?.(k)}
              onDragOver={(e) => { e.preventDefault(); setOverKey(k); }}
              onDragLeave={() => setOverKey((p) => (p === k ? null : p))}
              onDrop={(e) => { e.preventDefault(); setOverKey(null); onDropToVehicle?.(k); }}
              title={`${v.plaka} · ${t.count} sipariş · %${Math.round(ratio * 100)} dolu — sipariş bırakarak bu araca taşıyın`}
              style={{
                display: 'inline-flex', flexDirection: 'column', alignItems: 'stretch', gap: 3,
                minWidth: 92, padding: '5px 9px', borderRadius: 10, cursor: 'pointer',
                border: `1.5px ${isOver ? 'dashed' : 'solid'} ${isOver || isSel ? 'var(--accent)' : 'var(--border-color,#e5e7eb)'}`,
                background: isSel ? 'rgba(0,115,234,0.07)' : isOver ? 'rgba(0,115,234,0.05)' : 'var(--bg-soft,#fafbfc)',
              }}
            >
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 6 }}>
                <b style={{ fontSize: 12, color: 'var(--text-primary,#0f172a)' }}>{v.plaka}</b>
                <span style={{ fontSize: 10, fontWeight: 800, color: '#fff', background: 'var(--accent)', borderRadius: 999, padding: '0 6px' }}>{t.count}</span>
              </span>
              <span style={{ height: 4, borderRadius: 999, background: 'var(--border-color,#eef2f7)', overflow: 'hidden' }}>
                <span style={{ display: 'block', height: '100%', width: `${Math.min(100, Math.round(ratio * 100))}%`, background: barColor }} />
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export { keyOf as vehicleKeyOf };
